var _path, _ellipse, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImpulsionamento(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 216,
    height: 280,
    viewBox: "0 0 216 280",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.0892 102.226C35.5079 80.6687 41.9734 52.1835 63.5303 38.6022L80.3104 28.0304C104.142 13.0162 135.632 20.1638 150.646 43.9951L167.134 70.1649C179.022 89.0352 170.068 114.055 148.905 121.097L126.067 128.695C116.076 132.02 107.748 139.063 102.812 148.364V148.364C97.7935 157.82 84.428 158.317 78.7216 149.26L49.0892 102.226Z",
    fill: "#F4F0C8"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 107,
    cy: 267.227,
    rx: 81,
    ry: 12,
    fill: "#DDDCDC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M153.322 106.668L80.583 178.931C76.2033 183.282 69.3713 177.387 73.0344 172.417L133.783 90.0025C135.97 87.0347 134.303 82.8008 130.679 82.1214L122.729 80.6309C117.527 79.6555 117.209 72.323 122.307 70.9005L173.066 56.7373C176.47 55.7875 179.758 58.5723 179.381 62.0859L173.761 114.55C173.194 119.845 165.844 120.702 164.074 115.68L161.561 108.553C160.341 105.089 155.927 104.079 153.322 106.668Z",
    fill: "white",
    stroke: "#EBDC59",
    strokeWidth: 9
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImpulsionamento);
export default __webpack_public_path__ + "static/media/Impulsionamento.5870eb91c6656009590bc13a0c6d5950.svg";
export { ForwardRef as ReactComponent };